<ng-container *ngIf="{data: dataValidityI18nText$|async} as dataValidityI18n">
    <div class="mt-1 bg-primary text-white text-center" *ngIf="dataValidityI18n.data">{{ dataValidityI18n.data.label }}</div>
</ng-container>
